import tutorial0 from '../images/tutorial-0.jpg'
import tutorial1 from '../images/tutorial-1.jpg'
import tutorial2 from '../images/tutorial-2.jpg'
import tutorial3 from '../images/tutorial-3.jpg'

export const tutorialData = [
  {
    index: 0,
    img: tutorial0,
    description:
      "In the DoorDash Dasher app navigate to the 'Account' tab and tap 'Account data'.",
  },
  {
    index: 1,
    img: tutorial1,
    description: "Then on the manage account page, tap 'Request Data'.",
  },
  {
    index: 2,
    img: tutorial2,
    description: "Tap 'Request Data'.",
  },
  {
    index: 3,
    img: tutorial3,
    description:
      "In a few minutes you should be emailed a download link from doordash. (DD says it takes days but it's usually minutes)",
  },
  {
    index: 0,
    img: tutorial0,
    description:
      "After downloading/extracting the files, click 'Upload' below and select 'dasher_delivery_information.csv' file.",
  },
]
